import { lazy, Suspense } from 'react'
import { Outlet } from 'react-router-dom'
// auth
import { RoleBasedGuard, PermissionGuard } from 'src/auth/guard'
// components
import { LoadingScreen } from 'src/components/loading-screen'
import DashboardLayout from 'src/layout/dashboard/layout'

const CreateBudget = lazy(() => import('src/pages/dashboard/budgets/create'))
const BudgetsListView = lazy(() => import('src/pages/dashboard/budgets/list'))
const BudgetPreview = lazy(() =>
  import('src/pages/dashboard/budgets/preview').then((m) => ({ default: m.BudgetPreview })),
)
const ClientListView = lazy(() => import('src/pages/dashboard/clients/list'))
const PackageListView = lazy(() => import('src/pages/dashboard/packages/list'))
const HostingsListView = lazy(() => import('src/pages/dashboard/hostings/list'))
const HostingBudgetsListView = lazy(() => import('src/pages/dashboard/hosting-budgets/list'))
const CreateHostingBudget = lazy(() => import('src/pages/dashboard/hosting-budgets/create'))
const SettingsPage = lazy(() => import('src/pages/dashboard/settings'))
const UserListView = lazy(() => import('src/pages/dashboard/users/list'))
const KanbanPage = lazy(() => import('src/pages/dashboard/kanban'))
const TasksPage = lazy(() => import('src/pages/dashboard/tasks/index'))
const ReportsPage = lazy(() => import('src/pages/dashboard/reports'))
const BudgetsSummaryPage = lazy(() => import('src/pages/dashboard/reports/budgets-summary'))

// ----------------------------------------------------------------------

export const dashboardRoutes = [
  {
    path: 'dashboard',
    element: (
      <RoleBasedGuard hasContent roles={['admin', 'user']}>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </RoleBasedGuard>
    ),
    children: [
      { path: 'settings', element: <SettingsPage /> },
      {
        path: 'kanban',
        element: (
          <PermissionGuard hasContent permission='kanban'>
            <KanbanPage />
          </PermissionGuard>
        ),
      },
      {
        path: 'tarefas',
        element: (
          <PermissionGuard hasContent permission='tasks'>
            <TasksPage />
          </PermissionGuard>
        ),
      },
      {
        path: 'reports',
        children: [
          {
            element: (
              <PermissionGuard hasContent permission='reports'>
                <ReportsPage />
              </PermissionGuard>
            ),
            index: true,
          },
          {
            element: (
              <PermissionGuard hasContent permission='reports'>
                <BudgetsSummaryPage />
              </PermissionGuard>
            ),
            path: 'orcamentos',
          },
        ],
      },
      {
        path: 'users',
        children: [
          {
            element: (
              <PermissionGuard hasContent permission='users'>
                <UserListView />
              </PermissionGuard>
            ),
            index: true,
          },
        ],
      },
      {
        path: 'clients',
        children: [
          {
            element: (
              <PermissionGuard hasContent permission='clients'>
                <ClientListView />
              </PermissionGuard>
            ),
            index: true,
          },
        ],
      },
      {
        path: 'packages',
        children: [
          {
            element: (
              <RoleBasedGuard hasContent roles={['admin']}>
                <PackageListView />
              </RoleBasedGuard>
            ),
            index: true,
          },
        ],
      },
      {
        path: 'hostings',
        children: [
          {
            element: (
              <RoleBasedGuard hasContent roles={['admin']}>
                <HostingsListView />
              </RoleBasedGuard>
            ),
            index: true,
          },
        ],
      },
      {
        path: 'hosting-budgets',
        children: [
          {
            element: (
              <PermissionGuard hasContent permission='hostingBudgets'>
                <HostingBudgetsListView />
              </PermissionGuard>
            ),
            index: true,
          },
          {
            element: (
              <PermissionGuard hasContent permission='hostingBudgets'>
                <CreateHostingBudget />
              </PermissionGuard>
            ),
            path: 'create',
          },
          {
            element: (
              <PermissionGuard hasContent permission='hostingBudgets'>
                <CreateHostingBudget />
              </PermissionGuard>
            ),
            path: ':id/edit',
          },
        ],
      },
      {
        path: 'budgets',
        children: [
          {
            element: (
              <PermissionGuard hasContent permission='budgets'>
                <BudgetsListView />
              </PermissionGuard>
            ),
            index: true,
          },
          {
            element: (
              <PermissionGuard hasContent permission='budgets'>
                <CreateBudget />
              </PermissionGuard>
            ),
            path: 'create',
          },
          {
            element: (
              <PermissionGuard hasContent permission='budgets'>
                <BudgetPreview />
              </PermissionGuard>
            ),
            path: ':id/preview',
          },
        ],
      },
    ],
  },
]
